<template>
    <div class="form custom_form">
      <custom-mt-field
          v-model.trim="$v.old_password.$model"
          :label="labels.old_password"
          :placeholder="labels.old_password"
          :validationParam="$v.old_password"
          class="menu-item"
          type="password"
      ></custom-mt-field>

      <custom-mt-field
          v-model.trim="$v.new_password.$model"
          :label="labels.new_password"
          :placeholder="labels.new_password"
          :validationParam="$v.new_password"
          class="menu-item"
          type="password"
      ></custom-mt-field>

      <custom-mt-field
          v-model.trim="$v.new_password_confirmation.$model"
          :label="labels.new_password_confirmation"
          :messages="validation_error_messages.new_password_confirmation"
          :placeholder="labels.new_password_confirmation"
          :validationParam="$v.new_password_confirmation"
          class="menu-item"
          type="password"
      ></custom-mt-field>

      <div class="btn_section">
        <mt-button :disabled="$v.$invalid" class="ds-button-large confirm_btn" type="primary" @click="submit">
          {{ $t('general.confirm') }}
        </mt-button>
      </div>
    </div>
</template>

<script>
import { required, minLength, maxLength, sameAs } from 'vuelidate/lib/validators'
import CustomMtField from '../../basic/CustomMtField'
import { Toast } from 'mint-ui'

import { updatePassword } from '../../../api/member'

export default {
  name: 'PasswordForm',
  props: {
    type: String
  },
  components: {
    CustomMtField
  },
  validations: {
    old_password: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(20)
    },
    new_password: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(20)
    },
    new_password_confirmation: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(20),
      sameAs: sameAs('new_password')
    }
  },
  computed: {
    labels: function () {
      return {
        old_password: this.type === 'password' ? this.$i18n.t('member.profile.old_password') : this.$i18n.t('member.profile.old_payment_password'),
        new_password: this.type === 'password' ? this.$i18n.t('member.profile.new_password') : this.$i18n.t('member.profile.new_payment_password'),
        new_password_confirmation: this.type === 'password' ? this.$i18n.t('member.profile.new_password_confirmation') : this.$i18n.t('member.profile.new_payment_password_confirmation')
      }
    }
  },
  data () {
    return {
      validation_error_messages: {
        new_password_confirmation: {
          sameAs: this.$t('validation.sameAs', { eq: this.$t('member.profile.new_password') })
        }
      },
      old_password: '',
      new_password: '',
      new_password_confirmation: ''
    }
  },
  methods: {
    updatePassword,
    submit () {
      if (this.$v.$anyError) {
        return
      }

      const params = {
        update_password_type: this.type,
        old_password: this.old_password,
        new_password: this.new_password,
        new_password_confirmation: this.new_password_confirmation
      }

      updatePassword(params).then((res) => {
        Toast(res.message)

        this.old_password = ''
        this.new_password = ''
        this.new_password_confirmation = ''

        setTimeout(() => {
          this.$v.$reset()
          this.$emit('updatePassword', true)
        }, 0)
      }).catch((err) => {
        Toast(err.message)
      })
    }
  }
}
</script>

<style scoped>
.btn_section {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}
.confirm_btn {
  padding: 5px 20px;
  line-height: 20px;
  height: 28px;
}  
.custom_form >>> .mint-cell-wrapper {
  background-size: 120% 0px;
}
</style>